import { TFunction } from 'i18next';
import { Jane, SeniorityMethodEnum, ShiftParticipationEnum } from 'types/graphql';

export const shiftModalGeneralTabValueTextMarginLeft = 16;

export const displayedSeniorityLength = (
  seniorityMethod: SeniorityMethodEnum,
  rankingSeniorityDate: Jane['rankingSeniorityDate'],
  t: TFunction,
) => {
  if (seniorityMethod === SeniorityMethodEnum.years_months_days) {
    const days = !!rankingSeniorityDate?.seniorityDays
      ? `${rankingSeniorityDate.seniorityDays} ${
          rankingSeniorityDate.seniorityDays > 1 ? t('team_member:DAYS') : t('team_member:DAY')
        }`
      : '';
    const months = !!rankingSeniorityDate?.seniorityMonths
      ? `${rankingSeniorityDate.seniorityMonths} ${
          rankingSeniorityDate.seniorityMonths > 1
            ? t('team_member:MONTHS')
            : t('team_member:MONTH')
        }`
      : '';
    const years = !!rankingSeniorityDate?.seniorityYears
      ? `${rankingSeniorityDate.seniorityYears} ${
          rankingSeniorityDate.seniorityYears > 1 ? t('team_member:YEARS') : t('team_member:YEAR')
        }`
      : '';

    return !days && !months && !years ? '-' : `${years} ${months} ${days}`;
  } else {
    return !!rankingSeniorityDate?.seniorityHours
      ? `${rankingSeniorityDate.seniorityHours} ${
          rankingSeniorityDate.seniorityHours > 1 ? t('team_member:HOURS') : t('team_member:HOUR')
        }`
      : `-`;
  }
};

export const secondaryLocationSchedulingFilter = ({
  shiftParticipation,
}: {
  shiftParticipation: ShiftParticipationEnum;
}) =>
  shiftParticipation === ShiftParticipationEnum.all ||
  shiftParticipation === ShiftParticipationEnum.scheduling;

export const secondaryLocationCallOutFilter = ({
  shiftParticipation,
}: {
  shiftParticipation: ShiftParticipationEnum;
}) =>
  shiftParticipation === ShiftParticipationEnum.all ||
  shiftParticipation === ShiftParticipationEnum.callout;
